import { useEffect, useMemo } from "react";
import { useRawTable } from "../../hooks";

export default function Module_HealthManagement_HealthManagementStatisticsReport({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  totalRecord,
}) {
  const moduleDataTemp = useMemo(
    () => ({
      ...moduleData,
      columns: [
        ...moduleData.columns,
        ...(
          moduleData.categoryData?.SEX?.concat(
            moduleData.categoryData?.["年齡"]
          ) || []
        ).map((item) => ({
          key: item,
          field: `${item}_format`,
          header: item,
        })),
      ],
    }),
    [moduleData]
  );
  const { setTbData, renderTable } = useRawTable({
    setting: moduleDataTemp,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (!apiData) return;

    let tempData = moduleData.otherColumns.groupColumns.type.reduce(
      (preMain, curType) => ({
        ...preMain,
        [curType]: {
          ...moduleData.otherColumns.groupColumns.status.reduce(
            (preSub, curStatus) => ({
              ...preSub,
              [curStatus]: {},
            }),
            {}
          ),
        },
      }),
      {}
    );

    apiData.forEach((item) => {
      moduleData.otherColumns.groupColumns.type.forEach((type) => {
        let status = item[type];

        Object.keys(moduleData.categoryData).forEach((cgKey) => {
          let value = item[cgKey];

          if (cgKey === "EXMDAT") return;

          if (!tempData[type][status][value]) tempData[type][status][value] = 0;
          tempData[type][status][value]++;
        });
      });
    });

    let formatData = moduleData.otherColumns.groupColumns.type.reduce(
      (preMain, type) => [
        ...preMain,
        ...Object.entries(tempData[type]).map(([status, content], index) => {
          let total = Object.values(content).reduce(
            (pre, cur) => (pre += cur),
            0
          );

          return {
            type,
            rowSpan_type: index === 0 ? 3 : null,
            status,
            ...content,
            total: total / 2,
          };
        }),
      ],
      []
    );

    setTbData({
      raw: formatData,
      format: null,
      export: null,
    });
  }, [apiData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
      })}
    </>
  );
}
